import { QueryFunctionContext, useQuery } from "@tanstack/react-query";
import { configuration } from "src/configuration";
import { FetchError, GetFeedDto, queryKeys, useAccessToken } from "src/http";

const useGetMetricFeedRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function getMetricFeedRequest({
    queryKey,
  }: QueryFunctionContext<ReturnType<typeof queryKeys.metrics.getMetricFeed>>): Promise<GetFeedDto> {
    const accessToken = await getAccessToken();
    const [{ metricGuid }] = queryKey;

    const response = await fetch(`${configuration.apiRootUrl}/metrics/${metricGuid}/feed`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new FetchError(response);
    }

    return response.json();
  }

  return { getMetricFeedRequest };
};

const useGetMetricFeed = (metricGuid: string) => {
  const { getMetricFeedRequest } = useGetMetricFeedRequest();

  return useQuery({
    queryKey: queryKeys.metrics.getMetricFeed(metricGuid),
    queryFn: getMetricFeedRequest,
  });
};

export { useGetMetricFeed };
